<div *ngIf="loaded">
  <button
    [disabled]="isButtonDisabled"
    mat-raised-button
    color="primary"
    [matMenuTriggerFor]="menu"
    class="share-main-btn btn {{ btnClass }}"
  >
    <!-- Display the preloader or the button text -->
    <ng-container *ngIf="!isButtonDisabled; else preloader">
      {{ btnText }}
    </ng-container>
    <ng-template #preloader>
      <div class="preloader-wrapper">
        <div class="preloader"></div>
      </div>
    </ng-template>
  </button>

  <mat-menu #menu="matMenu" xPosition="before" class="share-dropdown-menu">
    <div class="share-dropdown-title">{{ btnText }}</div>

    <div class="share-dropdown-list">
      <ng-container *ngIf="getShareLink(CalendarItemEnum.Yahoo)">
        <a
          class="share-link"
          (click)="shareClick($event, CalendarItemEnum.Yahoo)"
        >
          <img
            [src]="getShareLink(CalendarItemEnum.Yahoo).icon"
            height="31"
            width="31"
            [alt]="getShareLink(CalendarItemEnum.Yahoo).text"
          />
        </a>
      </ng-container>
      <ng-container *ngIf="getShareLink(CalendarItemEnum.Desktop)">
        <a
          class="share-link"
          (click)="shareClick($event, CalendarItemEnum.Desktop)"
        >
          <img
            [src]="getShareLink(CalendarItemEnum.Desktop).icon"
            height="22"
            width="22"
            [alt]="getShareLink(CalendarItemEnum.Desktop).text"
          />
        </a>
      </ng-container>
      <ng-container *ngIf="getShareLink(CalendarItemEnum.Outlook)">
        <a
          class="share-link"
          (click)="shareClick($event, CalendarItemEnum.Outlook)"
        >
          <img
            [src]="getShareLink(CalendarItemEnum.Outlook).icon"
            height="20"
            width="20"
            [alt]="getShareLink(CalendarItemEnum.Outlook).text"
          />
        </a>
      </ng-container>
      <ng-container *ngIf="getShareLink(CalendarItemEnum.Gmail)">
        <a
          class="share-link"
          (click)="shareClick($event, CalendarItemEnum.Gmail)"
        >
          <img
            [src]="getShareLink(CalendarItemEnum.Gmail).icon"
            height="17"
            width="11"
            [alt]="getShareLink(CalendarItemEnum.Gmail).text"
          />
        </a>
      </ng-container>
    </div>
  </mat-menu>
</div>
